import { Component, OnInit, Injectable } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import 'hammerjs';
import { MonitoringService } from 'src/app/services/monitoring.service';

@Component({
  standalone: false,
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss']
})
export class EventFormComponent implements OnInit {

  constructor(private location: LocationStrategy, private toastrService: ToastrService, private monitoringService: MonitoringService) {

    history.pushState(null, null, "/#/register-event");

    // check if back or forward button is pressed.
    this.location.onPopState(() => {
      // set isBackButtonClicked to true.
      history.pushState(null, null, "/#/register-event");

      var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
      var message = 'Please use previous/next buttons in the form to navigate back/forward, so you do not lose your information.';

      if (isIEOrEdge) {
        alert(message);
      } else {
        var currMessages = this.toastrService.toasts.find(x => x.message == "Please use previous/next buttons in the form to navigate back/forward, so you do not lose your information.");

        if (!currMessages) {
          this.monitoringService.logEvent("Back button clicked");
          this.toastrService.warning(message, 'Attention', {
            timeOut: 10000,
            positionClass: "toast-top-left"
          });
        }
      }


      return false;
    });
  }

  ngOnInit() {
    this.monitoringService.logEvent("Landed on Form Wizard");
  }

}
